
import { NavLink, useParams } from "react-router";

import { usePagesByIdQuery } from "../../stores/OkOkStore";
import PagesEditForm from "../../components/Pages/PagesEditForm";
import { useTrads } from "../../contexts/trads/useTrads";

function PagesEdit(){
    const params = useParams();
    const {translate}=useTrads();
    const { data:page, error, isLoading } = usePagesByIdQuery(params.id??"0");

    return (

        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : page ? (
            <div>
                <nav>
                    <ul className="nav nav-tabs">
                        <li className="nav-item"><NavLink className="nav-link" to={`/traductions/${page.id.toString()}/edit`}>{translate('btn_edit')}</NavLink></li>
                    </ul>
                </nav>

                <PagesEditForm  pageParam={page} ></PagesEditForm>

            </div>

        ):null
    );
}
export default PagesEdit;